export default "__VITE_ASSET__B7O2eg5S__"